import { Component, OnInit } from "@angular/core";

@Component({
standalone: false,
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  currentYear: number;
  constructor() {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }
}
